export enum IncentiveType {
	SCHOLARSHIP_UPDATES = 'ScholarshipUpdates',
	EXPERIMENT = 'Experiment',
	HARD_WALL = 'HardWall',
	SP_CONNECT = 'SpConnect'
}
